import { ChangeDetectionStrategy, Component, computed, inject, viewChild } from '@angular/core';
import { ButtonModule } from 'primeng/button';
import { Popover, PopoverModule } from 'primeng/popover';
import { ThemeService } from '@pt/services/theme/theme.service';
import { ThemeMode } from '@pt/services/theme/theme.types';

interface ThemeModeOption {
  label: string;
  icon: string;
  value: ThemeMode;
}

@Component({
  selector: 'pt-theme-switcher',
  imports: [ButtonModule, PopoverModule],
  templateUrl: './theme-switcher.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PtThemeSwitcherComponent {
  private readonly themeService = inject(ThemeService);

  readonly mode = this.themeService.mode;

  readonly currentIcon = computed(() => {
    switch (this.mode()) {
      case 'light':
        return 'pi pi-sun';
      case 'dark':
        return 'pi pi-moon';
      default:
        return 'pi pi-desktop';
    }
  });

  readonly modeOptions: ThemeModeOption[] = [
    { label: 'System', icon: 'pi pi-desktop', value: 'system' },
    { label: 'Light', icon: 'pi pi-sun', value: 'light' },
    { label: 'Dark', icon: 'pi pi-moon', value: 'dark' },
  ];

  readonly popover = viewChild.required<Popover>('popover');

  togglePopover(event: Event): void {
    this.popover().toggle(event);
  }

  setMode(mode: ThemeMode): void {
    this.themeService.setMode(mode);
    this.popover().hide();
  }
}
